import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CloseBtn from '../../sections/Resources/components/CloseBtn';
import CheckMark from '../../images/checkmark-done.svg';

const Container = styled.div`
    width: max-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px 82px;
    position: relative;
    margin: 0 auto;
    @media only screen and (max-width: 560px) {
        padding: 24px 54px;
    }
`;

const Image = styled.img`
    height: 48.75px;
    width: 48.75px;
`;

const Heading = styled.h1`
    font-size: 20px;
    font-weight: 500;
    line-height: 18.96px;
    color: #1d2939;
    margin: 24px 12px;
    text-align: center;

    @media only screen and (max-width: 560px) {
        font-size: 16px;
    }
`;

const SubText = styled.p`
    max-width: 326px;
    font-size: 16px;
    color: #1d2939;
    line-height: 18.96px;
    text-align: ${({ textAlign }) => textAlign};

    @media only screen and (max-width: 560px) {
        max-width: 220px;
        font-size: 14px;
        line-height: 16.59px;
    }
`;

const ConfirmationModal = ({ confirmMessageHeading, message, textAlign = 'center' }) => {
    return (
        <Container>
            <Image src={CheckMark} alt="checkmark" />
            <Heading>{confirmMessageHeading || 'Thank You!'}</Heading>
            <SubText textAlign={textAlign}>{message}</SubText>
        </Container>
    );
};

ConfirmationModal.propTypes = {
    confirmMessageHeading: PropTypes.string,
    handleClose: PropTypes.func,
    message: PropTypes.string,
    textAlign: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
};
export default ConfirmationModal;
